import React from 'react';

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  subscribed: { label: 'Subscribed', className: 'bg-green-100 text-green-800' },
  trial: { label: 'Trial', className: 'bg-blue-100 text-blue-800' },
  trial_end: { label: 'Trial expired', className: 'bg-orange-100 text-orange-800' },
  locked: { label: 'Not purchased', className: 'bg-gray-100 text-gray-800' },
  seat_locked: { label: 'Seat locked', className: 'bg-amber-100 text-amber-800' },
  subscription_end: { label: 'Subscription ended', className: 'bg-red-100 text-red-800' },
  ended: { label: 'Ended', className: 'bg-red-100 text-red-800' },
  grace: { label: 'Grace', className: 'bg-amber-100 text-amber-800' },
  grace_ended: { label: 'Grace ended', className: 'bg-orange-100 text-orange-800' },
  pending: { label: 'Pending', className: 'bg-gray-100 text-gray-700' },
  'n/a': { label: 'N/A', className: 'bg-gray-50 text-gray-500' },
  admin: { label: 'Admin', className: 'bg-purple-100 text-purple-800' },
};

interface SubscriptionStatusBadgeProps {
  status: string;
  className?: string;
}

const SubscriptionStatusBadge: React.FC<SubscriptionStatusBadgeProps> = ({ status, className = '' }) => {
  const normalized = status?.toLowerCase() ?? '';
  const config = STATUS_CONFIG[normalized] ?? {
    label: status || 'Unknown',
    className: 'bg-gray-100 text-gray-700',
  };

  return (
    <span
      className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
};

export default SubscriptionStatusBadge;
